
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_181_1724)"}},[_c('path',{attrs:{"d":"M10.105 7.816l.3.357H19.53c.518 0 .939.42.94.94V19.55c-.001.519-.422.94-.94.94 0 0 0 0 0 0H1.94s0 0 0 0a.941.941 0 01-.94-.94V6.96c0-.515.416-.935.931-.94h6.663l1.511 1.796z","stroke":"#282828","stroke-width":"2"}}),_c('path',{attrs:{"d":"M22.075 4.665h-8.661L11.69 2.618a.294.294 0 00-.235-.106H4.472a1.939 1.939 0 00-1.917 1.675h6.37c.333 0 .65.147.865.403l1.47 1.748h8.271a2.776 2.776 0 012.772 2.772v9.854a1.939 1.939 0 001.699-1.923V6.601a1.941 1.941 0 00-1.927-1.936z","fill":"#282828"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_181_1724"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    